let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aEyK4")).then(() => parcelRequire('hB1C9'));